import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import {
	Route,
	Redirect,
	Switch
} from 'react-router-dom';
import Dashboard from './content/Dashboard';
import AdminContainer from './containers/AdminContainer';
import AccountsContainer from './containers/AccountsContainer';
import SettingsContainer from './containers/SettingsContainer';
import ReportStandaloneContainer from './containers/ReportStandaloneContainer';
import { Grid } from 'material-ui';

const styles = {
	Content: {
		display: 'flex',
		justifyContent: 'center',
		padding: '0 2em',
		backgroundColor: '#EEEEEE',
		minHeight: '100vh'
	},
	paper: {
		marginTop: '170px',
		marginBottom: '50px',
		padding: '2em',
		width: '100%'
	},
	table: {
		minWidth: 700,
	},
};

class Content extends Component {
	constructor(props) {
		super(props)

		this.state = {
			'open': false,
			'errorMsg': ''
		}
	}

	handleClose = () => {
		this.setState({
			'open': false,
			'errorMsg': ''
		})
	}

	checkErrors = (props, state = null) => {
		let appState = props.appState
		let errorMsg = ''

		for (let item in appState) {
			if (appState[item] && appState[item].error) {
				errorMsg = appState[item].errorMsg
				appState[item].error = false
				appState[item].errorMsg = null
				this.setState({
					'open': true,
					'errorMsg': errorMsg
				})
				props.state({ type: 'CLEAR_STORE', data: appState })
			}
		}
	}

	componentWillMount() {
		this.checkErrors(this.props)
	}

	componentWillReceiveProps(nextProps) {
		this.checkErrors(nextProps)
	}

	classes = this.props.classes;

	render() {
		const { open, errorMsg } = this.state
		const { account } = this.props
		return account && account.user ? 
			<div className={this.classes.Content}>
				<Snackbar
					anchorOrigin={{
						vertical: "top",
						horizontal: "center"
					}}
					open={open}
					autoHideDuration={4000}
					onClose={this.handleClose}
					message={
						<span id="error-message">
							{errorMsg}
						</span>
					}
				/>
				<Grid container className={'container-max-width'}>
					<Paper className={`${this.classes.paper}`}>
						<Switch>
							{/* <Route path="/admin" exact component={Dashboard} /> */}
							<Route path="/admin/stages/" exact component={AdminContainer} />
							<Route path="/admin/levels/:id/edit" exact component={AdminContainer} />
							<Route path="/admin/stages/:id" exact component={AdminContainer} />
							<Route path="/admin/accounts/" exact component={AccountsContainer} />
							<Route path="/admin/accounts/:id" exact component={AccountsContainer} />
							<Route path="/admin/accounts/:id/reports/:type" exact component={ReportStandaloneContainer} />
							<Route path="/admin/settings/" exact component={SettingsContainer} />
							<Route path="/admin/settings/:tab" exact component={SettingsContainer} />
							<Redirect exact from="/" to={account.user && account.user.type === 'superadmin' ? "/admin/accounts/" : "/admin/accounts/" + account.user.account_id} />
							<Redirect exact from="/admin" to={account.user && account.user.type === 'superadmin' ? "/admin/accounts/" : "/admin/accounts/" + account.user.account_id} />
						</Switch>
					</Paper>
				</Grid>
			</div>
		: null
	}
}

Content = withRouter(connect(
	state => ({
		appState: state
	}),
	dispatch => ({
		state: data => dispatch(data)
	})
)(Content));

export default withStyles(styles)(Content);



// WEBPACK FOOTER //
// ./src/components/Content.js